import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as InfoIcon } from '@zonofi/svg-icons/input-info.svg';
import './price-info-tool-tip.scss';

interface PriceInfoTooltipProp {
  title: string;
  subText: React.ReactNode;
  heading: string;
}

export const PriceInfoTooltip: React.FC<PriceInfoTooltipProp> = ({
  title,
  subText,
  heading,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [open]);

  return (
    <div ref={wrapperRef}>
      <Tooltip
        open={open}
        disableHoverListener
        disableFocusListener
        disableTouchListener
        arrow
        placement="bottom-start"
        slotProps={{
          tooltip: {
            sx: {
              bgcolor: '#1f2a37',
              color: '#fff',
              fontSize: 13,
              padding: '10px 14px',
              borderRadius: '8px',
              boxShadow: '0px 8px 20px rgba(0,0,0,0.2)',
              top: '-15px',
            },
          },
          arrow: {
            sx: {
              color: '#1f2a37',
            },
          },
        }}
        title={
          <div>
            <div className="tool-tip-main-view">
              <InfoIcon color="#fff" />
              <div>
                <div className="tool-tip-title font-semibold">{title}</div>
                <div className="tool-tip-sub-title font-medium">{subText}</div>
              </div>
            </div>
          </div>
        }
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            setOpen((prev) => !prev);
          }}
          className="tool-tip-heading-view"
        >
          <span className="tool-tip-heading-view--text font-semibold">
            {heading}
          </span>
          <InfoIcon color="#000" style={{ marginTop: '1px' }} />
        </div>
      </Tooltip>
    </div>
  );
};
